export class VirkRegError extends Error {
  statusCode: number;
  nolog: boolean;
  apiError: string;
  apiErrorMessage?: string;

  constructor(
    message: string,
    statusCode: number,
    nolog: boolean,
    apiError: string,
    apiErrorMessage?: string,
  ) {
    super(message);
    this.statusCode = statusCode;
    this.nolog = nolog;
    this.apiError = apiError;
    this.apiErrorMessage = apiErrorMessage;
  }
}

export class EntrypointLoadError extends VirkRegError {
  constructor(virkRegError: VirkRegError) {
    super(
      virkRegError.message,
      virkRegError.statusCode,
      virkRegError.nolog,
      virkRegError.apiError,
      virkRegError.apiErrorMessage,
    );
  }
}
